exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-component__logo-wrap{position:absolute;top:50%;left:50%;width:320px;height:64px;margin-top:-32px;margin-left:-160px}.error-component__logo{width:320px;height:64px}.error-component__link{font-size:2em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/pages/error.scss
// module id = 1015
// module chunks = 0